import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { blogArticlePath, type MarketingLocale } from '../../config/localeRoutes';
import type { BlogArticleLink } from './fetchAllBlogArticles';

type Props = {
  locale: MarketingLocale;
  articles: BlogArticleLink[];
};

/** #1084 — même bloc « Tous les articles » que seo-bot / HTML statique. */
export default function BlogAllArticlesNav({ locale, articles }: Props) {
  const { t } = useTranslation('marketing');
  const label = t('blogPage.allArticlesNav.title', { defaultValue: 'Tous les articles' });

  if (!articles.length) return null;

  return (
    <nav
      className="blog-all-articles"
      data-blog-seo="all-articles"
      aria-label={label}
      lang={locale}
    >
      <h2 className="blog-all-articles__title">{label}</h2>
      <ul className="blog-all-articles__list">
        {articles.map((article) => (
          <li key={article.slug}>
            <Link to={blogArticlePath(locale, article.slug)}>{article.title}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
